//@flow
import * as React from 'react'
import InvoiceItemsForm from './InvoiceItemsForm';
import AddInvoiceItemForm from './AddInvoiceItemForm';
import MaterialPaperWrap from '../../components/common/MaterialPaperWrap'
import type { InvoiceLineItemsContainer$Props } from './flowTypes'

const InvoiceLineItemsContainer=(props:InvoiceLineItemsContainer$Props)=>{
    let children = <InvoiceItemsForm jwt={props.jwt} taskAcceptedInfoId={props.taskAcceptedInfoId} />

    if (props.isTriggerAddLineItem){
        children = <AddInvoiceItemForm jwt={props.jwt} taskAcceptedInfoId={props.taskAcceptedInfoId} />
    }

    return (
        <div className='row'>
           <div className='col-sm'>
             <MaterialPaperWrap>
                {children}
             </MaterialPaperWrap>
           </div>
        </div>
    )
}

export default InvoiceLineItemsContainer


// WEBPACK FOOTER //
// ./src/views/ProjectDemeter/InvoiceLineItemsContainer.js